import { signOutAndRedirect } from 'lib/AuthClient/authentication';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { findLongestSubstringFromStart } from '../../utils/strings';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import './NavigationDrawer.scss';

type LinkProperties = { to: string; text: string };
type NavLinks = ReadonlyArray<LinkProperties>;
type NavLinksWithState = ReadonlyArray<
  LinkProperties & {
    isActive?: boolean;
  }
>;

type InnerProps = {
  close: () => void;
  open: () => void;
  isOpen: boolean;
  navLinks: NavLinksWithState;
};

const NavigationDrawerInner: React.FC<InnerProps> = ({
  close,
  open,
  isOpen,
  navLinks,
}) => {
  return (
    <SwipeableDrawer
      className="sidenav mobile-only"
      anchor="left"
      onClose={close}
      onOpen={open}
      open={isOpen}
      classes={{ paper: 'background' }}
    >
      {
        // Using a paragraph with accessibility mapping can be useful to work
        // around SEO concerns of having multiple <h1> per page.
        // See: https://twitter.com/goetsu/status/1261253532315004930
        //
        // Copied from react-a11y-dialog (https://github.com/KittyGiraudel/react-a11y-dialog/blob/fd529fc3ad1403a785d586d10961cc974c83635a/index.js#L51-L54)
        <p role="heading" aria-level={1} className="visually-hidden">
          Dispatch page navigation
        </p>
      }
      <nav>
        <ul>
          {navLinks.map(x => {
            return (
              <li key={x.text} className={x.isActive && 'current'}>
                <NavLink to={x.to} onClick={close} className="nav-list-item">
                  {x.text}
                </NavLink>
              </li>
            );
          })}
          <li>
            <button onClick={signOutAndRedirect} className="nav-list-item">
              Sign out
            </button>
          </li>
          <li>
            <button onClick={close} className="nav-list-item">
              Close navigation
            </button>
          </li>
        </ul>
      </nav>
    </SwipeableDrawer>
  );
};

type Props = {
  close: () => void;
  open: () => void;
  isOpen: boolean;
  navLinks: NavLinks;
};

export const NavigationDrawer: React.FC<Props> = ({ navLinks, ...props }) => {
  const activeLink = findLongestSubstringFromStart(
    window.location.pathname,
    navLinks.map(x => x.to)
  );
  const navLinksWithState = navLinks.map(x => ({
    ...x,
    isActive: x.to === activeLink,
  }));

  return <NavigationDrawerInner {...props} navLinks={navLinksWithState} />;
};
